<template>
  <div class="flex items-center">
    <input
      id="image"
      ref="fileInputField"
      type="file"
      class="inputfile"
      @change="onFileSelected"
    />
    <label
      for="image"
      class="text-sm"
    >
      <span
        v-if="loadFile"
        class="text-green-500"
      >
        {{ alreadyLoadText }}
      </span>
      <span v-else>{{label}} </span>

    </label>
    <div class="ml-4">
      <button
        v-if="loadFile"
        class="btn btn-default btn-small"
        @click="removeFile"
      >
        {{ $t('main.button_delete') }}
      </button>
      <button
        v-else
        class="btn btn-default btn-small"
        @click="selectFile"
      >
        {{ $t('client.file_input_block.button_upload') }}
      </button>
    </div>

  </div>
</template>
<script>
export default {
  name: "FileInputBlock",
  props: {
    loadedFile: {
      type: [String, File],
      required: false,
      default: "",
    },
    selectedImageFileNameDefault: {
      type: String,
      required: false,
      default: "",
    },
    alreadyLoadText: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      label: "",
      loadFile: null,
    };
  },
  created() {
    this.label = this.selectedImageFileNameDefault;
    this.loadFile = this.loadedFile;
  },
  methods: {
    selectFile() {
      this.$refs.fileInputField.click();
    },
    onFileSelected(event) {
      this.$emit("selected-file", event.target.files[0]);
      this.imagePreview = this.defaultImagePreview;
      this.label = null;
      let file = event.target.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.label = file[0].name;
        this.loadFile = file[0].name;
      }
    },
    removeFile() {
      this.$emit("remove-file");
      this.label = this.selectedImageFileNameDefault;
      this.loadFile = null;
    },
  },
};
</script>
